import { render, staticRenderFns } from "./MyTakePartIn.vue?vue&type=template&id=3072ba8d&scoped=true"
import script from "./MyTakePartIn.vue?vue&type=script&lang=js"
export * from "./MyTakePartIn.vue?vue&type=script&lang=js"
import style0 from "./MyTakePartIn.vue?vue&type=style&index=0&id=3072ba8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072ba8d",
  null
  
)

export default component.exports